import React from 'react';
import styled from 'styled-components';
import { IconBase, IconBaseProps } from './IconBase';

const Icon = styled(IconBase)`
  fill: none;
  stroke: ${(props) =>
    props.color ? props.theme.palette[props.color][props.shade || 'main'] : 'currentColor'};
`;

export const Envelope = (props: IconBaseProps) => (
  <Icon {...props} viewBox="0 0 20 20">
    <rect x="1" y="4" width="18" height="12" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M19 4L10 11L1 4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1 16L8 10M19 16L12 10"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
